module.exports = __webpack_public_path__ + "img/noContentEmptyState.231b3dad.png";